import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Override(props: IconProps): JSX.Element {
  return <Override.Outline {...props} />;
}

Override.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M13 18.1785C13.4142 18.1785 13.75 18.5143 13.75 18.9285C13.75 19.3427 13.4142 19.6785 13 19.6785H7C6.58579 19.6785 6.25 19.3427 6.25 18.9285C6.25 18.5143 6.58579 18.1785 7 18.1785H13Z"
          fill="currentColor"
        />
        <path
          d="M17.25 12.9285C17.25 11.5086 17.2494 10.5 17.1699 9.71851C17.0917 8.94946 16.9431 8.48348 16.7021 8.1228C16.465 7.768 16.1604 7.4634 15.8057 7.22632C15.445 6.98532 14.979 6.83678 14.21 6.75855C13.4284 6.67907 12.4199 6.67847 11 6.67847C9.58012 6.67847 8.57157 6.67907 7.79004 6.75855C7.021 6.83678 6.55501 6.98533 6.19434 7.22632C5.83955 7.46341 5.53494 7.76801 5.29785 8.1228C5.05686 8.48347 4.90831 8.94946 4.83008 9.71851C4.7506 10.5 4.75 11.5086 4.75 12.9285V18.9285C4.75 19.3427 4.41421 19.6785 4 19.6785C3.58579 19.6785 3.25 19.3427 3.25 18.9285V12.9285C3.25 11.5396 3.24887 10.4413 3.33789 9.56616C3.42819 8.67865 3.61773 7.93794 4.05078 7.2898C4.39734 6.77115 4.84268 6.32581 5.36133 5.97925C6.00947 5.54619 6.75019 5.35666 7.6377 5.26636C8.51281 5.17734 9.61115 5.17847 11 5.17847C12.3888 5.17847 13.4872 5.17734 14.3623 5.26636C15.2498 5.35666 15.9905 5.5462 16.6387 5.97925C17.1572 6.3258 17.6026 6.7712 17.9492 7.2898C18.3823 7.93794 18.5718 8.67865 18.6621 9.56616C18.7511 10.4413 18.75 11.5396 18.75 12.9285V17.1179L20.4697 15.3982C20.7626 15.1053 21.2374 15.1053 21.5303 15.3982C21.8232 15.6911 21.8232 16.1658 21.5303 16.4587L18.5303 19.4587C18.2374 19.7516 17.7626 19.7516 17.4697 19.4587L14.4697 16.4587C14.1768 16.1658 14.1768 15.6911 14.4697 15.3982C14.7626 15.1053 15.2374 15.1053 15.5303 15.3982L17.25 17.1179V12.9285Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
